import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import AppRouter from 'app/AppRouter';

import './styles/css/font.css';
import './styles/css/style.css';
import './styles/scss/content-style.css';
import './styles/scss/global.css';

const basePath = process.env.REACT_APP_PATH || '';

const router = createBrowserRouter(AppRouter, { basename: `${basePath}/` });

const queryClient = new QueryClient({
  defaultOptions: {
    retry: 0,
    queries: { refetchOnMount: false, refetchOnReconnect: false, refetchOnWindowFocus: false },
  },
});

// msw 처리 보완 필요
// async function enableMocking() {
//   if (process.env.REACT_APP_MODE !== 'test') {
//     return Promise.resolve();
//   }

//   const { worker } = await import('./app/lib/msw');

//   return worker.start({ serviceWorker: { url: `/mockServiceWorker.js` } });
// }

// enableMocking().then(() => {
createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>,
);
// });
